import proyectos from "../../data/proyects.json";

function Proyects() {
  return (
    <div className="mt-32">
      <div>
        <div className="container mx-auto bg-gray-400 h-96 rounded-md flex items-center bg-[url('https://senda.pe/wp-content/uploads/2023/06/LUMICA_CANAVAL_Ingreso-scaled.jpg')] bg-cover bg-center">
          <div className="sm:ml-20 text-gray-50 text-center sm:text-left bg-black/50 p-4 rounded-md">
            <h2 className="text-5xl font-bold mb-4">
              Descubre tu próximo hogar
            </h2>
            <p className="text-lg inline-block sm:block">
              Explora nuestros proyectos inmobiliarios y encuentra el
              departamento ideal para ti.
            </p>
          </div>
        </div>
      </div>
      <div className="py-16 container mx-auto px-6 md:px-0">
        <section>
          <h1 className="text-3xl font-bold text-gray-600 mb-10">
            Proyectos destacados
          </h1>
          <div className="grid sm:grid-cols-3 gap-4 grid-cols-1">
            {proyectos.map((proyecto, index) => (
              <div
                key={index}
                className="rounded-lg overflow-hidden border border-gray-200 shadow-sm"
              >
                <a href={`/proyectos/${proyecto.id}`}>
                  <img
                    src={proyecto.imagenes[0].imgUrl}
                    alt={proyecto.nombre}
                    className="w-full h-80 object-cover"
                  />
                  <div className="p-2">
                    <h3 className="text-lg font-semibold text-gray-500 mt-2">
                      {proyecto.nombre}
                    </h3>
                    <p className="text text-gray-400 pt-1">
                      {proyecto.descripcion}
                    </p>
                  </div>
                </a>
              </div>
            ))}
          </div>
          <hr className="w-40 my-14 border-4 rounded-md sm:mx-0 mx-auto border-primary" />
        </section>
        <section>
          <h1 className="inline-block text-gray-600 font-bold text-3xl">
            ¿Cómo funciona el proceso?
          </h1>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-10">
            <div>
              <h3 className="text-lg font-semibold text-gray-500 mt-2">
                1. Explora los proyectos
              </h3>
              <p className="text text-gray-400">
                Revisa nuestros proyectos inmobiliarios y encuentra el que mejor
                se adapte a tus necesidades y presupuesto.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-500 mt-2">
                2. Agenda una visita
              </h3>
              <p className="text text-gray-400">
                Contáctanos para programar una visita y conocer el proyecto en
                persona. Nuestros asesores estarán listos para ayudarte.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-500 mt-2">
                3. Reserva tu departamento
              </h3>
              <p className="text text-gray-400">
                Una vez que encuentres el lugar ideal, inicia el proceso de
                compra con asesoría personalizada y opciones de financiamiento.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Proyects;
